import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { trackMetaPixelPageView, isPublicPage } from '../lib/metaPixel'

/**
 * Hook to track Meta Pixel page views on public pages
 * Automatically tracks PageView when route changes on public pages
 */
export const useMetaPixel = () => {
  const location = useLocation()

  useEffect(() => {
    // Only track on public pages
    if (isPublicPage(location.pathname)) {
      // Small delay to ensure Meta Pixel is loaded
      const timer = setTimeout(() => {
        trackMetaPixelPageView(location.pathname)
      }, 100)

      return () => clearTimeout(timer)
    }
  }, [location.pathname])
}

